import { Injectable, inject } from '@angular/core';
import { Product, SimplifiedProduct } from '@oe-backend/types';
import { ResponseObjectApiInterface } from 'src/app/types/interfaces/api-responses/response-object.api.interface';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../../base-api/base-api.service';

@Injectable({ providedIn: 'root' })
export class ProductsService extends BaseApiService {
	private http = inject(HttpClient);

	fetchProducts() {
		return this.http
			.get<ResponseObjectApiInterface<SimplifiedProduct[]>>(`${this.apiBaseUrl}/Products`)
			.pipe(
				map((response: ResponseObjectApiInterface<SimplifiedProduct[]>) => {
					return response.data;
				}),
			);
	}

	fetchProduct(id: string) {
		return this.http
			.get<ResponseObjectApiInterface<Product>>(`${this.apiBaseUrl}/Products/${id}`)
			.pipe(
				map((response: ResponseObjectApiInterface<Product>) => {
					return response.data;
				}),
			);
	}
}
